import { jsx as _jsx } from "react/jsx-runtime";
var Empty = function Empty() {
    return (_jsx("span", {}));
};
export default Empty;
